import script from "./OnboardingStep3.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingStep3.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingStep3.vue?vue&type=style&index=0&id=976ec32a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-976ec32a"]])

export default __exports__